import React from 'react';
import { ChartBarIcon } from '@heroicons/react/20/solid';

import Sidebar from '@components/Sidebar';

const OnboardingInsights = ({ disabled }) => {
	return (
		<Sidebar.Item to="/unify-onboarding/insights" disabled={disabled}>
			<ChartBarIcon />
			Insights
		</Sidebar.Item>
	);
};

export default OnboardingInsights;
